import { useEffect } from 'react';

import { PanelStatus } from '@foradevelopment/fora-ui';
import { matomoTracking, reportSalaryMatomo } from '@fora-monorepo/webapp-analytics';

import { useAppSelector } from '../../redux/hooks';
import { PayrollInputPanel } from './PayrollInputPanel';
import { ReceiptPanel } from './ReceiptPanel';
import { ReviewAndConfirmPanel } from './ReviewAndConfirmPanel';
import { PayrollInputPanelOld } from './PayrollInputPanelOld';

export const ManualPayrollReportingPanelList = () => {
  const payrollInputPanelState = useAppSelector(state => state.payroll.payrollInputPanelState);
  const reviewAndConfirmPayReportPanelState = useAppSelector(
    state => state.payroll.reviewAndConfirmPayReportPanelState
  );
  const receiptPanelState = useAppSelector(state => state.payroll.receiptPanelState);
  const ffManageEmployeeAndEmployment = useAppSelector(
    state => state.foraGlobal.settings.ffManageEmployeeAndEmployment
  );

  useEffect(() => {
    if (payrollInputPanelState.status === PanelStatus.Active) {
      matomoTracking(reportSalaryMatomo, 'rapportera löner');
    }
    if (reviewAndConfirmPayReportPanelState.status === PanelStatus.Active) {
      matomoTracking(reportSalaryMatomo, 'granska och bekräfta');
    }
    if (receiptPanelState.status === PanelStatus.Active) {
      matomoTracking(reportSalaryMatomo, 'kvittens');
    }
  }, [payrollInputPanelState.status, reviewAndConfirmPayReportPanelState.status, receiptPanelState.status]);

  return (
    <>
      {ffManageEmployeeAndEmployment && <PayrollInputPanel />}
      {!ffManageEmployeeAndEmployment && <PayrollInputPanelOld />}
      <ReviewAndConfirmPanel />
      <ReceiptPanel />
    </>
  );
};
